import store from "../store";

export default class LimeAPI {
  // tslint:disable-next-line: strict-boolean-conditions
  static apiUrl = process.env.REACT_APP_LIME_API_URL;

  static async request(
    endpoint: string,
    method: string,
    signal: AbortSignal,
    body = {},
  ) {
    const headers = {
      "Content-Type": "application/json",
      "Session-Token": store.getState().user.sessionToken,
    };

    let args: object = { method, headers, signal };

    if (Object.keys(body).length > 0) {
      body = JSON.stringify(body);
      args = { body, ...args };
    }

    try {
      let url = `${this.apiUrl}/${endpoint}`;
      const response = await fetch(url, args);
      const text = await response.text();

      try {
        return JSON.parse(text);
      } catch (parseError) {
        return {
          success: false,
          error: true,
          status: response.status,
          bodySnippet: text ? text.slice(0, 200) : "",
          data: { message: "" },
        };
      }
    } catch (error) {
      const aborted =
        (error instanceof DOMException || error instanceof Error) &&
        error.name === "AbortError";

      return {
        success: false,
        error: true,
        aborted,
        errorName: error instanceof Error ? error.name : "unknown",
        errorMessage: error instanceof Error ? error.message : "",
        data: { message: "" },
      };
    }
  }

  static async get(endpoint: string, signal: AbortSignal) {
    return this.request(endpoint, "GET", signal);
  }

  static async post(endpoint: string, body: {}, signal: AbortSignal) {
    return this.request(endpoint, "POST", signal, body);
  }

  static async delete(endpoint: string, signal: AbortSignal) {
    return this.request(endpoint, "DELETE", signal);
  }

  static async put(endpoint: string, body: {}, signal: AbortSignal) {
    return this.request(endpoint, "PUT", signal, body);
  }
}
